// used for query params purposes
export const REPAIR_REPORT_CHECK_STATE = "repair_report_check_state";
export const PREARATION_VISIT_TASK_STATE = "preparation_visit_task_state";
